import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {CarouselComponent} from '@aviary/components/carousel/carousel.component';
import {CarouselItemDirective} from '@aviary/components/carousel/carousel-item/carousel-item.directive';
import {CatalogCarouselItemComponent} from '@app/catalog/carousels/catalog-carousel-item.component';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {NgClass} from '@angular/common';

@Component({
  selector: 'px-catalog-carousel-card',
  template: `
    <mat-card>
      <mat-card-title [ngClass]="titleClasses">{{ carouselTitle }}</mat-card-title>
      <mat-card-content class="px-3">
        <div class="px-10 relative">
          <mx-carousel [buttonIconSize]="8" [extendButtons]="false" [noItemsMessage]="noItemsMessage" buttonClasses="bg-ref-neutral-variant-95 text-success"
                       buttonIconClasses="translate-y-0.5" class="pt-3 pb-3 [--mx-button-fab-container-size:2.25rem] [--mx-button-fab-icon-size:2rem]">
            @for (catalogRecord of carouselItems; track catalogRecord.id) {
              <px-catalog-carousel-item mxCarouselItem [catalogRecord]="catalogRecord"/>
            }
          </mx-carousel>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselComponent, CarouselItemDirective, CatalogCarouselItemComponent, MatCard, MatCardContent, MatCardTitle, NgClass]
})
export class CatalogCarouselCardComponent {
  @Input() public carouselTitle: string = '';
  @Input({required: true}) public carouselItems: CatalogRecord[];
  @Input() public noItemsMessage: string = '';
  @Input() public titleClasses: string = '';
}
